import { useState } from 'react';

import SelectionsConferenceChampsData from './SelectionsConferenceChampsData';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const useSelectionsConferenceChampsData = () => {
  const [selectionsConferenceChampsState, setSelectionsConferenceChampsState] = useState(INITIAL_STATE);

  const getSelectionConferenceChamps = () => {
    return SelectionsConferenceChampsData.getSelectionConferenceChampsData(selectionsConferenceChampsState, setSelectionsConferenceChampsState);
  };

  const putSelectionConfirmNCAAConfChamps = (champsArray) => {
    return SelectionsConferenceChampsData.putSelectionConfirmNCAAConfChampsData(champsArray, selectionsConferenceChampsState, setSelectionsConferenceChampsState);
  };

  const putSelectionProcessNCAAConfChamps = () => {
    return SelectionsConferenceChampsData.putSelectionProcessNCAAConfChampsData(selectionsConferenceChampsState, setSelectionsConferenceChampsState);
  };

  const putSelectionClearNCAAConfChampsConfirmation = (ncaaConferenceChampionsId) => {
    return SelectionsConferenceChampsData.putSelectionClearNCAAConfChampsConfirmationData(ncaaConferenceChampionsId, selectionsConferenceChampsState, setSelectionsConferenceChampsState);
  };

  return {
    selectionsConferenceChampsState,
    getSelectionConferenceChamps,
    putSelectionConfirmNCAAConfChamps,
    putSelectionProcessNCAAConfChamps,
    putSelectionClearNCAAConfChampsConfirmation
  };
};

export default useSelectionsConferenceChampsData;